module.exports = __webpack_public_path__ + "img/grabme.2c11a26d.svg";